export default "__VITE_ASSET__BDiLxY$D__"